module.exports = __webpack_public_path__ + "static/img/zh.1e957e9c.png";